import PropTypes from "prop-types";
import { Link } from "react-router-dom";
const DemoTradingAccountContentTwo = () => {
  return (
    <div
      className="ht__bradcaump__area_market"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side_ai_1.png"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container_market">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <h1>Explore Global Markets With Zero Risk</h1>
              <p>
                Step into real market conditions, test your strategies, and
                build confidence with a fully immersive demo experience and no
                deposit, no pressure, just pure learning.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Start Practicing Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DemoTradingAccountContentTwo.propTypes = {
  title: PropTypes.string,
};

export default DemoTradingAccountContentTwo;
